import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import EditMessageModal from './EditMessage';

const ModalsManager = ({ modal, onHide, onSubmit }) => {
  const modalsComponentsList = [
    {
      modalKey: 'edit',
      Component: EditMessageModal,
      options: {
        bsSize: undefined,
        className: '',
      },
    },
  ]
  if (modalsComponentsList.length) {
    return modalsComponentsList.map((item) => {
      const { Component, options, name } = item;
      const showModal = modal?.openModalKey === item.modalKey;
      return (
        <Modal
          key={`modal-${name}`}
          show={showModal}
          backdrop="static"
          onHide={onHide}
          {...options}
        >
          <Component
            onHide={onHide}
            onSubmit={onSubmit}
            data={modal?.data}
          />
        </Modal>
      )
    })
  }
  return null;
}

ModalsManager.propTypes = {
  modal: PropTypes.object,
  open: PropTypes.string,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isLoadingSubmit: PropTypes.bool,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ModalsManager;
